import { render, staticRenderFns } from "./RegionEdit.vue?vue&type=template&id=467b11dd&scoped=true"
import script from "./RegionEdit.vue?vue&type=script&lang=js"
export * from "./RegionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467b11dd",
  null
  
)

export default component.exports